// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "point-2RQX4";
var _3 = "link-_LgX5";
var _4 = "airportName-SNEQP";
var _5 = "terminal-1ky1G";
export { _1 as "__esModule", _2 as "point", _3 as "link", _4 as "airportName", _5 as "terminal" }
export default { "__esModule": _1, "point": _2, "link": _3, "airportName": _4, "terminal": _5 }
